module.exports = __webpack_public_path__ + "media/images/common/nav_bg-32638e1647be159df534c14575eae32d.png";